"use client";

import { Route } from "next";
import Link from "next/link";
import posthog from "posthog-js";

interface TrackedLinkProps {
    href: string;
    id: string;
    className?: string;
    children: React.ReactNode;
    trackingData: {
        eventName: string;
        properties: Record<string, any>;
    };
}

export default function TrackedLink({
    href,
    id,
    className,
    children,
    trackingData,
}: TrackedLinkProps) {
    return (
        <Link
            href={href as Route}
            id={id}
            className={className}
            onClick={() => {
                posthog?.capture(
                    trackingData.eventName,
                    trackingData.properties,
                );
            }}
        >
            {children}
        </Link>
    );
}
